/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Streak_FreezeInputs */

const en_us2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 freeze week saved`)
};

const pt_br2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 semana de folga guardada`)
};

const es_419_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 semana de descanso guardada`)
};

const pt_pt2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 semana de folga guardada`)
};

const fr_fr2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 semaine joker en réserve`)
};

const de_de2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Pausenwoche gespart`)
};

const it_it2_progress_streak_freeze = /** @type {(inputs: Progress_Streak_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 settimana di pausa da parte`)
};

/**
* | output |
* | --- |
* | "1 freeze week saved" |
*
* @param {Progress_Streak_FreezeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_streak_freeze = /** @type {((inputs?: Progress_Streak_FreezeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Streak_FreezeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_streak_freeze(inputs)
	if (locale === "es-419") return es_419_progress_streak_freeze(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_streak_freeze(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_streak_freeze(inputs)
	if (locale === "de-DE") return de_de2_progress_streak_freeze(inputs)
	if (locale === "it-IT") return it_it2_progress_streak_freeze(inputs)
	return en_us2_progress_streak_freeze(inputs)
});
export { progress_streak_freeze as "progress.streak_freeze" }